export default __webpack_public_path__ + "static/media/mona-idle-no-logo.354b06b2.mp4";